// User management
import UserManagement from '@/views/admin/userManagement.vue'
import UserStatsFilter from '@/views/admin/userManagement/userStatsFilter.vue'
import UMUser from '@/views/admin/userManagement/user.vue'
import UMViewUser from '@/views/admin/userManagement/userInfo.vue'
import UMStaffs from '@/views/admin/userManagement/staffs.vue'
import UMFeedbacks from '@/views/admin/userManagement/feedback.vue'
import UMAmbassador from '@/views/admin/userManagement/ambassador.vue'

import FundTransfer from '../../views/admin/userManagement/fundTransfer.vue'
// import AdminFundTransfer from '../../views/admin/userManagement/adminFundTransfer.vue'
import BonusConversion from '../../views/admin/userManagement/bonusConversion'
import Referrals from '../../views/admin/userManagement/referrals'
import Wallet from '../../views/admin/userManagement/wallet'
import WalletHistory from '../../views/admin/userManagement/walletHistory.vue'
import cashbackWalletHistory from '../../views/admin/userManagement/cashbackHistory.vue'
// import CryptoWallets from '@/views/admin/userManagement/cryptoWallets.vue'
import CryptoWalletHistory from '@/views/admin/userManagement/cryptoWalletHistory.vue'
import PromoCodeHistory from '../../views/admin/promoCodes/promoCodeHistory.vue'
import TokenBonusConversion from '../../views/admin/userManagement/tokenConversion'
import Cashback from '@/views/admin/userManagement/cashback.vue'

const userRoutes = {
  path: '/hrd12/hrd12/users-management',
  component: UserManagement,
  redirect: '/hrd12/hrd12/sales/users-management/users',
  name: 'UserManagement',
  meta: {
    title: 'UserManagement'
  },
  children: [
    {
      path: '/hrd12/hrd12/users-management/users',
      component: UMUser,
      name: 'AllUsers',
      meta: {
        title: 'Users'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/user-stats-filter',
      component: UserStatsFilter,
      name: 'UserStatsFilter',
      meta: {
        title: 'User Stats Filter'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/view-user/:id',
      component: UMViewUser,
      name: 'ViewUser',
      meta: {
        title: 'View User'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/feedbacks',
      component: UMFeedbacks,
      name: 'Feedbacks',
      meta: {
        title: 'Feedbacks'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/staffs',
      component: UMStaffs,
      name: 'Staff',
      meta: {
        title: 'Staff'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/ambassador',
      component: UMAmbassador,
      name: 'Ambassador',
      meta: {
        title: 'Ambassador'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/funds-transfer',
      component: FundTransfer,
      name: 'FundTransfer',
      meta: {
        title: 'Fund Transfer'
      }
    },
    // {
    //   path: '/hrd12/hrd12/users-management/yurd2m-funds-transfer',
    //   component: AdminFundTransfer,
    //   name: 'AdminFundTransfer',
    //   meta: {
    //     title: 'Admin Fund Transfer'
    //   }
    // },
    {
      path: '/hrd12/hrd12/users-management/bonus-conversion',
      component: BonusConversion,
      name: 'BonusConversion',
      meta: {
        title: 'Bonus Conversion'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/referrals',
      component: Referrals,
      name: 'ReferralsCount',
      meta: {
        title: 'Referral Count'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/token-conversion',
      component: TokenBonusConversion,
      name: 'TokenBonusConversion',
      meta: {
        title: 'Token Bonus Conversion'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/user-wallet',
      component: Wallet,
      name: 'UsersWallet',
      meta: {
        title: 'Wallet'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/user-cashback',
      component: Cashback,
      name: 'UsersCashback',
      meta: {
        title: 'Cashback'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/user-wallet-history',
      component: WalletHistory,
      name: 'UsersWalletHistory',
      meta: {
        title: 'Wallet History'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/crypto-wallet-history',
      component: CryptoWalletHistory,
      name: 'CryptoWalletHistory',
      meta: {
        title: 'Crypto Wallet History'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/cashback-wallet-history',
      component: cashbackWalletHistory,
      name: 'UsersCashbackWalletHistory',
      meta: {
        title: 'Cashback History'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/user-bill-history',
      component: () =>
        import('../../views/admin/userManagement/billHistory.vue'),
      name: 'UsersBillHistory',
      meta: {
        title: 'Bill History'
      }
    },
    {
      path: '/hrd12/hrd12/users-management/promo-code-history',
      component: PromoCodeHistory,
      name: 'PromoCodeHistory',
      meta: {
        title: 'Promo Code History'
      }
    }
  ]
}

export default userRoutes
